import https from "@/lib/https";
import type {
  IndustryDetail,
  IndustryPayload,
  GetIndustryListParams,
} from "@/interface/masterManagement";
import type { ApiResponse, PaginationResponse } from "@/interface/common";

const BASE_URL = "/api/master/industries/";

export const getIndustryList = async (
  params?: GetIndustryListParams,
): Promise<
  ApiResponse<PaginationResponse<IndustryDetail> | IndustryDetail[]>
> => {
  return await https.get<
    ApiResponse<PaginationResponse<IndustryDetail> | IndustryDetail[]>
  >(BASE_URL, params);
};

export const createIndustry = async (
  payload: IndustryPayload,
): Promise<ApiResponse<IndustryDetail>> => {
  return await https.post<ApiResponse<IndustryDetail>>(BASE_URL, payload);
};

export const updateIndustry = async (
  id: number | string,
  payload: IndustryPayload,
): Promise<ApiResponse<IndustryDetail>> => {
  return await https.put<ApiResponse<IndustryDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteIndustry = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
